import { render, staticRenderFns } from "./salesforce-contact-settings.vue?vue&type=template&id=8e1c0162&scoped=true"
import script from "./salesforce-contact-settings.vue?vue&type=script&lang=js"
export * from "./salesforce-contact-settings.vue?vue&type=script&lang=js"
import style0 from "./salesforce-contact-settings.vue?vue&type=style&index=0&id=8e1c0162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1c0162",
  null
  
)

export default component.exports